import { Extension } from '@tiptap/core';
import Suggestion, { type SuggestionOptions } from '@tiptap/suggestion';
import type { VariableType, VariableNodeAttributes } from './variable-node';

export interface SuggestionItem {
  type: VariableType;
  name: string;
  description?: string;
  preview?: string;
  defaultValue?: string;
}

export interface VariableSuggestionOptions {
  suggestion: Omit<SuggestionOptions<SuggestionItem>, 'editor'>;
}

export const VariableSuggestion = Extension.create<VariableSuggestionOptions>({
  name: 'variableSuggestion',

  addOptions() {
    return {
      suggestion: {
        char: '{{',
        allowSpaces: false,
        startOfLine: false,
        command: ({ editor, range, props }) => {
          const attrs: VariableNodeAttributes = {
            type: props.type,
            name: props.name,
            preview: props.preview,
            ...(props.type === 'slot' && props.defaultValue != null
              ? { defaultValue: props.defaultValue }
              : {}),
          };

          editor
            .chain()
            .focus()
            .deleteRange(range)
            .insertVariable(attrs)
            .run();
        },
      },
    };
  },

  addProseMirrorPlugins() {
    return [
      Suggestion({
        editor: this.editor,
        ...this.options.suggestion,
      }),
    ];
  },
});
